import { render, staticRenderFns } from "./wirelessWifi.vue?vue&type=template&id=c64d502c&scoped=true&"
import script from "./wirelessWifi.vue?vue&type=script&lang=js&"
export * from "./wirelessWifi.vue?vue&type=script&lang=js&"
import style0 from "./wirelessWifi.vue?vue&type=style&index=0&id=c64d502c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d502c",
  null
  
)

export default component.exports